import reducer from './reducers';
import * as lockersActions from './actions';
import * as lockersSelectors from './selectors';
import lockersSagas from './sagas';

export {lockersActions, lockersSelectors, lockersSagas};

export default reducer;
